<template lang="pug">
.search-input-container
	tooltip.tooltip(v-if="tooltip" :text="tooltip")
		input.input(type="search" :placeholder="placeholder" :value="value" @input="$emit('input', $event.target.value)")
		button.button.square.button--clear-input.button--ghost.button--ghost-hover.button--icon-only(@click="$emit('input', '')" v-show="!!value && value != ''"): i.fas.fa-times
	.div(v-else)
		input.input(type="search" :placeholder="placeholder" :value="value" @input="$emit('input', $event.target.value)")
		button.button.square.button--clear-input.button--ghost.button--ghost-hover.button--icon-only(@click="$emit('input', '')" v-show="!!value && value != ''"): i.fas.fa-times

</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";
import Tooltip from "@/components/InformationTooltip";

@Component({
	props: {
		value: { default: "" },
		placeholder: { default: "Search" },
		tooltip: { default: null }
	},
	components: {
		Tooltip
	}
})
class SearchInput extends Vue {}

export default SearchInput;
</script>

<style lang="stylus" scoped>
.search-input-container
	align-items center
	justify-content flex-start
	display flex
	position relative

	.input
		width 350px

	&::before
		display block
		position absolute
		left 0.50em
		padding-right 5px
		pointer-events none
		opacity 0.5
		font-size 18px
		top 0.6em
		z-index 1
		font-family 'Font Awesome 5 Free', sans-serif
		font-weight 900
		content '\f002'

	input[type="search"]
		padding-left 2em
		padding-right 2em
		font-size 18px

	// clears the 'X' from Internet Explorer
	input[type=search]::-ms-clear {  display: none; width : 0; height: 0; }
	input[type=search]::-ms-reveal {  display: none; width : 0; height: 0; }

	// clears the 'X' from Chrome
	input[type="search"]::-webkit-search-decoration,
	input[type="search"]::-webkit-search-cancel-button,
	input[type="search"]::-webkit-search-results-button,
	input[type="search"]::-webkit-search-results-decoration { display: none; }

button.button.square.button--clear-input
	position absolute
	right 0

@media screen and (max-width: 500px)
	.search-input-container
		display inline-block
		width 15%

		input[type="search"]
			padding-left 2em
			padding-right 2em
			font-size 15px

		.input
			width 200px
</style>
